import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { BestoranteService } from "src/app/services/bestorante";
import { CardPaymentService } from "src/app/services/cardpayment.service";
import { ConfigurationService } from "src/app/services/configuration";
import { DateService } from "src/app/services/date.service";
import { NetworkService } from "src/app/services/network.service";
import { ReceiptStore } from "src/app/services/receiptstore";
import { UtilsService } from "src/app/services/utils";
import { ReceiptRow } from "src/app/types/receiptrow";
import { Receipt } from "src/app/types/receipt";
import { PaymentRow } from "src/app/types/paymentrow";
import { ModalController } from "@ionic/angular";
// eslint-disable-next-line max-len
import { ReconciliationConfirmationModalPage } from "src/app/modal/reconciliation-confirmation-modal/reconciliation-confirmation-modal.page";
import { ReconciliationService } from "src/app/services/reconciliation.service";
import { StorageService } from "src/app/services/storage.service";
import { RestolutionService } from "src/app/services/restolution";
import { ReceiptService } from "src/app/services/receipt.service";
import { report } from "process";

@Component({
  selector: "app-sales-report",
  templateUrl: "./sales-report.component.html",
  styleUrls: ["./sales-report.component.scss"],
})
export class SalesReportComponent implements OnInit, OnDestroy{
  selectedDate = moment();
  selectedReceipts: Receipt[] = [];
  selectedRows: ReceiptRow[] = [];
  selectedPaymentTypes = {};
  selectedPaymentRows = [];
  numOfNonReconciliatedReceipts: number;
  salesReceiptsNo = 0;
  vatSum = 0;
  noVatSum = 0;
  voidNo = 0;
  productNo = 0;
  vatCategories = [];
  isReconciliated = false;
  isReconciliationInProgress = false;
  receiptNr: number;

  subs = [];

  objectKeys = Object.keys;

  dateStream;

  constructor(private receipts: ReceiptStore, private besto: BestoranteService, private resto: RestolutionService,
    private utils: UtilsService, private date: DateService, private translate: TranslateService, private conf: ConfigurationService,
    private cardPayment: CardPaymentService, private modalController: ModalController, private network: NetworkService,
    private reconciliation: ReconciliationService, private storage: StorageService, private receiptService: ReceiptService) {}

  ngOnInit() {
    this.subs.push(this.date.dateStream.subscribe(data => {
      this.isReconciliated = false;
      this.selectedDate = data.date;
      this.selectedReceipts = this.receipts.getFilteredReceipts(this.utils.receiptsFilterFunc, this.selectedDate);
      this.resetSums();
      this.getRowsFromReceipts();
      this.getnumOfNonReconciliatedReceipts();
      this.caclculateProductsSold();
      this.areReceiptsReconciliated();
      this.selectedPaymentTypes = this.calculatePaymentTypesSums(this.selectedPaymentRows, this.selectedPaymentTypes);
      this.calculateVATs();
    }));
    this.subs.push(this.receiptService.receiptNrStream.subscribe(
      (num: number) => { this.receiptNr = num; }
    ));
  };


  getRowsFromReceipts() {
    let rows = [];
    let paymentRows = [];
    let selectedPaymentTypes = {};
    this.voidNo = 0;

    for (const receipt of this.selectedReceipts) {
      if (!(receipt.hasCancelReceipt || receipt.cancelReceipt || receipt.reportReceipt)) {
        rows = this.extractRows(receipt.rows, rows);
        [paymentRows, selectedPaymentTypes] = this.extractPaymentRowsAndTypes(receipt.payments, paymentRows, selectedPaymentTypes);
      } else if (receipt.cancelReceipt) {
        this.voidNo += 1;
      }
    }
    this.selectedRows = rows;
    this.selectedPaymentRows = paymentRows;
    this.selectedPaymentTypes = selectedPaymentTypes;
    this.salesReceiptsNo = this.selectedReceipts.filter((rec: Receipt) => !rec.reportReceipt).length;
  }

  extractRows(newRows: any[], rows: any[] = [],): any[] {
    let currentGroup = "";

    for (const row of newRows) {
      if (rows.find(product => product.name === row.name)) {
        rows = rows.map(product =>
          product.name === row.name ? {...product, amount: product.amount + row.amount} : product);
      } else {
        if (this.conf.guestMode) {
          currentGroup = "food";
        } else {
          currentGroup = this.besto.groups.find(group => group.uuid === row.groupUuid) ?
          this.besto.groups.find(group => group.uuid === row.groupUuid).name :
          this.besto.subGroups.find(group => group.uuid === row.groupUuid).name;
        }
        rows.push({
          ...row,
          group: currentGroup
        });
      }
    }

    return rows;
  }

  extractPaymentRowsAndTypes(newRows: any[], rows: any[] = [], selectedPaymentTypes = {}): any[] {
    for (const paymentRow of newRows) {
      rows.push(paymentRow);
      const payment = this.translate.instant(paymentRow.payment.charAt(0).toUpperCase() + paymentRow.payment.slice(1).toLowerCase());
      if (!Object.keys(selectedPaymentTypes).includes(payment)) {
        selectedPaymentTypes = {...selectedPaymentTypes, [payment]: 0 };
      }
    }

    return [rows, selectedPaymentTypes];
  }

  areReceiptsReconciliated() {
    if (this.selectedReceipts.every((receipt: Receipt) => receipt.reconciliationDate || receipt.reportReceipt)) {
      this.isReconciliated = true;
    } else {
      this.isReconciliated = false;
    }
  }

  getnumOfNonReconciliatedReceipts() {
    this.numOfNonReconciliatedReceipts = this.selectedReceipts.filter((receipt: Receipt) => !receipt.reconciliationDate).length;
    if (this.numOfNonReconciliatedReceipts === 0) {
      this.isReconciliated = true;
    }
  }

  resetSums() {
    this.vatSum = 0;
    this.noVatSum = 0;
    this.vatCategories = [];
    this.selectedPaymentRows = [];
    this.selectedPaymentTypes = {};
  }

  caclculateProductsSold() {
    this.productNo = this.selectedRows.reduce((sum, product: ReceiptRow) => sum + product.amount, 0);
  }

  calculatePaymentTypesSums(paymentRows: PaymentRow[], paymentTypes = {}) {
    paymentRows.map((row: PaymentRow ) => {
      const p = this.translate.instant(row.payment.charAt(0).toUpperCase() + row.payment.slice(1).toLowerCase());
      paymentTypes[p] += row.realSum ? row.realSum : row.sum;
    });
    return paymentTypes;
  }

  async confirmReconciliation() {
    this.isReconciliationInProgress = true;
    const numOfReconciliationReceipts = this.selectedReceipts
      .filter((receipt: Receipt) => !receipt.reconciliationDate && !receipt.reportReceipt).length;
    const modal = await this.modalController.create({
      component: ReconciliationConfirmationModalPage,
      componentProps: {
        receiptsAmount: numOfReconciliationReceipts
      },
      cssClass: "bestogo-modal modal-xs"
    });
    await modal.present();
    const status: any = await modal.onWillDismiss();
    if (status.data.msg === "Ok") {
      const reconciliationDate = new Date();
      this.selectedReceipts = this.selectedReceipts.map((receipt: Receipt) => {
        if (!receipt.reconciliationDate && !receipt.reportReceipt) {
          receipt.reconciliationDate = reconciliationDate;
        }
        return receipt;
      });
      this.receipts.sentReceipts = this.receipts.sentReceipts.map((sentReceipt: Receipt) => {
        this.selectedReceipts.map((receipt: Receipt) => {
          if (!sentReceipt.reconciliationDate && receipt.guid === sentReceipt.guid) {
            sentReceipt.reconciliationDate = receipt.reconciliationDate;
          }
        });
        return sentReceipt;
      });
      this.receipts.unsentReceipts = this.receipts.unsentReceipts.map((unsentReceipt: Receipt) => {
        this.selectedReceipts.map((receipt: Receipt) => {
          if (!unsentReceipt.reconciliationDate && receipt.guid === unsentReceipt.guid) {
            unsentReceipt.reconciliationDate = receipt.reconciliationDate;
          }
        });
        return unsentReceipt;
      });
      this.reconciliation.addDate(this.selectedDate.toDate());
      let reconciledRows = [];
      let reconciledProductsNo = 0;
      let reconciledPaymentRows = [];
      let reconciledPaymentTypes = {};
      this.selectedReceipts
        .filter((receipt: Receipt) =>
          receipt.reconciliationDate === reconciliationDate && !receipt.reportReceipt && !receipt.cancelReceipt && !receipt.hasCancelReceipt
        )
        .map((receipt: Receipt) => {
          reconciledRows = this.extractRows(receipt.rows, reconciledRows);
          [reconciledPaymentRows, reconciledPaymentTypes] =
            this.extractPaymentRowsAndTypes(receipt.payments, reconciledPaymentRows, reconciledPaymentTypes);
        });
        reconciledRows.map((row: ReceiptRow) => {
          reconciledProductsNo += row.amount;
        });
      reconciledPaymentTypes = this.calculatePaymentTypesSums(reconciledPaymentRows, reconciledPaymentTypes);
      const lineWidth = this.conf.paymentTerminal === "POPLATEKWS" ? 26 : 30;
      const reconciliationPrintOut = this.reconciliation.createReconciliationReceipt(
        reconciledRows,
        reconciledPaymentTypes,
        lineWidth,
        reconciliationDate,
        reconciledProductsNo,
        this.conf.confData,
        this.besto.restaurant,
        status.data.clerkId
      );
      this.receipts.addReceiptForSending(
        {
          methodOfPayment: "CASH",
          // eslint-disable-next-line quote-props
          "number": this.receiptNr,
          date: reconciliationDate,
          reportReceipt: true,
          reconciliationReceipt: true,
          clerkID: status.data.clerkID,
          clientID: this.resto.currentLogin.clientId,
          guid: this.utils.generateGUIDString(),
          vats: {},
          discounts: [],
          payments: [],
          rows: reconciledRows,
          total: 0,
          printOut: reconciliationPrintOut.join("\n\r"),
        }
      );
      this.reconciliation.endOfDayReconciliation(reconciliationDate);
      this.receipts.writeToStorage();
      await this.receiptService.increaseAndGetReceiptNumber();
      this.isReconciliated = true;
    }
    this.isReconciliationInProgress = false;
  }

  calculateVATs() {
    this.selectedRows.map(product => {
      if (product.price > 0) {
      const rowPrice = product.price * product.amount;
      if (!this.vatCategories?.some(cat => product.vat === cat.vat )) {
        this.vatCategories.push(
          { vat: product.vat,
            sum: rowPrice - (rowPrice * (product.vat / 100)),
            label: `${this.translate.instant("VAT")} ${product.vat}%`
          });
      } else {
        this.vatCategories = this.vatCategories.map(cat =>
          product.vat === cat.vat ? {...cat, sum: cat.sum + (rowPrice - (rowPrice * (product.vat / 100)))} : cat);
      }
      this.vatSum += product.price * product.amount;
      this.noVatSum += rowPrice - (rowPrice * (product.vat / 100));
    }
    });
  }

  ngOnDestroy(): void {
    for (const s of this.subs) {
      if (s && s.unsubscribe) {
        s.unsubscribe();
      }
    }
  }
}
